<template>
  <div class="story-item" @click="goDes">
    <div class="user-info">
      <div class="avatar">
        <img :src="basicInfo.avatar | imgZip(100)" alt="头像" />
      </div>
      <div class="user-des">
        <div class="des-top">
          <div class="name">{{ basicInfo.nickname }}</div>
          <div class="level" v-if="firstIdentity">
            <!-- <img
              class="icon-level"
              :src="firstIdentity.image | imgZip(54)"
              alt=""
            /> -->
            <span class="level-text">{{ firstIdentity.name }}</span>
          </div>
        </div>
        <div class="des-bottom">{{ detailInfo.created }}</div>
      </div>
    </div>
    <div class="content">
      <YxlMore
        :isClickShow="false"
        :lineClamp="4"
        :info="detailInfo.content"
        @hook:updated="yxlMoreUpdated"
      ></YxlMore>
    </div>
    <div class="tag" v-if="detailInfo.topic_id" @click.stop="goTagDes">
      <i class="icon-tag"></i>
      <span class="tag-text">{{ detailInfo.topic_name }}</span>
    </div>
    <HandList :info="interactive"></HandList>
  </div>
</template>
<script>
import YxlMore from 'component/common/yxlMore.vue'
import HandList from 'component/platform/homepage/common/handList.vue'
import { imgZip } from 'app/web/filters/ossImg.js'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
export default {
  mixins: [homepageMixin],
  props: {
    storyInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    YxlMore,
    HandList
  },
  data() {
    return {
      info: `知心朋友不一定知心。但是一定交心。这世间知己太少，能遇到一个就是莫大的幸运知心朋友不一定知心。但是一定交心。这世间知己太少，能遇到一个就是莫大的幸运知心朋友…。这世间知己太少，能遇到一个就是莫大的幸运知心朋友…`
    }
  },
  computed: {
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    detailInfo() {
      return this.storyInfo.detail || ''
    },
    interactive() {
      return this.storyInfo.interactive || ''
    },
    firstIdentity() {
      return this.$store.getters['homepage/firstIdentity']
    }
  },
  created() {},
  mounted() {},
  methods: {
    imgZip,
    yxlMoreUpdated() {
      this.$emit('updated')
    },
    goDes() {
      this.$emit('goDes')
      this.routerPushWithoutNav(
        `https://m.xinli001.com/qa/real_time_story_detail/${this.detailInfo.id}`
      )
    },
    goTagDes() {
      this.$emit('goTagDes')
      this.routerPushWithoutNav(
        `https://m.xinli001.com/qa/real_time_topics_detail_${this.detailInfo.topic_id}`
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.story-item {
  padding: 30px;
  margin-bottom: 30px;
  background: #ffffff;
  box-shadow: 0px 0px 40px 0px #ebefff, 0px 0px 40px 0px rgba(0, 0, 0, 0.03);
  border-radius: 30px;
  overflow: hidden;
  .user-info {
    display: flex;
    align-items: center;
    .avatar {
      > img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .user-des {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 20px;
      .des-top {
        display: flex;
        .name {
          max-width: 300px;
          font-size: 28px;
          color: #21252d;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .level {
          display: flex;
          align-items: center;
          padding: 3px 12px;
          margin-left: 6px;
          background: #fff1ee;
          border-radius: 20px;
          box-sizing: border-box;
          .level-text {
            font-size: 20px;
            margin-left: 4px;
            color: #ff745b;
            font-weight: normal;
          }
        }
      }
      .des-bottom {
        margin-top: 6px;
        font-size: 26px;
        color: #9da3ac;
      }
    }
  }
  .content {
    margin-top: 30px;
    font-size: 30px;
    color: #6c798c;
    line-height: 49px;
    text-shadow: 0px 0px 40px #ebefff;
  }
  .tag {
    padding: 10px;
    margin-top: 24px;
    display: inline-flex;
    align-items: center;
    background: #fff0f0;
    box-shadow: 0px 0px 40px 0px #ebefff;
    border-radius: 25px;
    .icon-tag {
      width: 30px;
      height: 30px;
      background: url('../../../../images/platform/homepage/icon-tag.png')
        no-repeat center/100% 100%;
    }
    .tag-text {
      margin-left: 8px;
      font-size: 24px;
      color: #ff745b;
    }
  }
}
</style>
